import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { SearchService } from '@services/search.service';
import { CreateService } from '@services/create.service';
import { GlobalService } from '@common/global';
import * as _ from 'lodash';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
@Component({
  selector: 'app-topic-list',
  templateUrl: './topic-list.component.html',
  styleUrls: ['./topic-list.component.sass']
})
export class TopicListComponent implements OnInit {

 
  @Input('c') component: string;
  @Input('a') application: string;
  @Input('rows') rows: number;
  @Input('mediaId') mediaId: string;
  @Input('mediaType') mediaType: string;
  @Input('mediaName') mediaName: string;
  @Input('loginurl') loginurl: string;
  review_count = 0;
  form_renter = false;
  reviews: any = [];
  dataLoding = true;
  params: any = [];
  pageCounter = 1;
  btn_process = false;
  isLogin = false;
  reviewRate = 0;
  review_error: any = { "name": "", "description": "" };
  constructor(private router: Router, private _createService: CreateService, private fb: FormBuilder, private _searchService: SearchService, private _global: GlobalService) { }
  topicForm: FormGroup;
 // @ViewChild(RatingValueComponent, { static: false }) ratingElem: RatingValueComponent;
  ngOnInit(): void {

    this.loadReview();

    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }
    this.topicForm = this.fb.group({
      name: [this.mediaName],
      description: []
    });


  }

  rating(e) {
    this.reviewRate = e
  }

  loadReview() {

    let pa = {
      component: this.component,
      application: 'review',
      start: 0,
      rows: this.rows,
      mediaId: this.mediaId,
      sortOrder: 'desc',
      sortString: 'createdTime'
    };
    this._searchService.appreview(pa).subscribe(
      reviewList => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(reviewList, 'response.docs', ''))) {
          this.params = this._global.getVal(reviewList, 'request', {});
          this.review_count = this._global.getVal(reviewList, 'response.numFound', '0');
          this.reviews = this._global.getVal(reviewList, 'response.docs', {});
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  onScrollDown() {
    if (!this.dataLoding) {
      this.dataLoding = true;
      if (this.review_count <= this.pageCounter * this.rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._searchService.appreview(p).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.reviews = this.reviews.concat(this._global.getVal(data, 'response.docs', []));
              this.dataLoding = false;
              this.pageCounter += 1;
              this.params = this._global.getVal(data, 'request', '');
            } else {
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });

      }
    }
  }
  saveReview() {
   
    this.review_error = { "name": "", "description": "" };
    this.btn_process = true;
    let p = this.topicForm.value;
    p = this._global.paramsRemoveNull(p);
    p['mediaName'] = this.mediaName;
    p['mediaId'] = this.mediaId
    p['application'] = 'review';
    p['status'] = 'pending';
    p['rating'] = this.reviewRate;
    p['component'] = this.component;
    p['mediaType'] = this.mediaType;
    this._createService.review(p).subscribe(
      data => {
        this.btn_process = false;
        if (data["status"] == "1") {
          this._global.showMessage({ "type": 'success', "message": "Review Created Success" });
          let r=this.reviews;
          this.reviews=[];
          this.reviews.push(data["response"]);
          this.reviews = this.reviews.concat(r);
        //  this.reviews = this.reviews.concat(data["response"]);
          this.topicForm.reset();
          this.reviewRate = 0;
          this.form_renter = false;
        } else {
          for (let key in data["errors"]) {
            this.review_error[key] = data["errors"][key]["message"];
          }
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  gotoLogin() {
    this.router.navigate(['/login'], { queryParams: { returnUrl: this.loginurl, 'navigateByUrl': true } });
  }

}
